export default __webpack_public_path__ + "static/media/img-sample-img.8442ccc0.png";